import { ButtonModule } from 'primeng/button';
import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CustomButton } from '../../../models/customButton';
import { ReportsServicesService } from '../../../services/reports-services.service';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';
import { LoaderComponent } from "../../../utils/loader/loader.component";
import { DatepickerComponent } from "../../../utils/datepicker/datepicker.component";
import { CustomTableComponent } from "../../../utils/custom-table/custom-table.component";

@Component({
    selector: 'app-comission-invoice',
    imports: [ButtonModule, LoaderComponent, DatepickerComponent, CustomTableComponent],
    templateUrl: './comission-invoice.component.html',
    styleUrl: './comission-invoice.component.scss'
})
export class ComissionInvoiceComponent {
 data: any;
  tokenAuth: any;
  fromDate!: Date;
  toDate!: Date;
  loading=true;
  reporterURL=environment.wrUrl;
  headers: any[] = [
    { key: "date", textHeader: "Emisión", visible: true, type: "date" },
    { key: "serieFolio", textHeader: "Factura", visible: true, type: "string" },
    { key: "total", textHeader: "Importe", visible: true, type: "currency" },
   
  ];

  tblButtons:CustomButton[] = [
    
    {
      text: 'Factura',
      action: (event: any) => this.generateInvoice(event, 'pdf'),
      icon: undefined,
      color: '',
      hasIcon: false,
      showText: true,
    },

    {
      text: 'XML',
      action: (event: any) => this.generateInvoice(event, 'xml'),
      icon: undefined,
      color: '',
      hasIcon: false,
      showText: true,
    },
   
  ]
  requestFrom: any;

  requestTo: any;

  invoices!: any[];
  constructor(private rptServices: ReportsServicesService, private titleService:Title,private themeService:ThemeService
    
  ) {
    this.themeService.setTitle("Facturas por comisión");
    this.titleService.setTitle("Facturas por comisión")

    this.data = JSON.parse(localStorage.getItem('data')!); 
  }
  ngAfterViewInit(): void {
    this.getStatement();
  }

  ngOnInit() {
    let today = new Date();
    this.fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
    this.toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

 
  }
  setDatesOnFilter(event: any) {

    this.fromDate = event.from;
    this.toDate = event.to;

  }

  getStatement() {
    this.loading=true;
    this.requestFrom = new Date(this.fromDate);
    this.requestTo = new Date(this.toDate);

    this.rptServices.getComissionInvoice(this.data.Client_number, this.requestFrom, this.requestTo).subscribe({
      next: (resp: any) => {
        this.loading=false;  
        this.invoices = resp;
      },
       error :(error: any) =>{
        this.loading=false;
        this.invoices=[]
       }
    })
  }

  generateReportConsumptions(invoice: any, type: string) {

   
   let url ='' 
   if(type=='pdf'){
    url = this.reporterURL+type+'/MonederoXiga.aspx?rptId=data&rptName=rpt_ConsumptionsByInvoice&invoice='+invoice.id+'&clientId='+this.data.Client_id+'&langId=2';
   }else if(type=='excel' ){
    url = this.reporterURL+type+'/MonederoXiga.aspx?rptName=statement&invoice='+invoice.id+'&clientId='+this.data.Client_id;
   }else{
    url = this.reporterURL+'pdf/MonederoXiga.aspx?rptId=txt&invoice='+invoice.id+'&clientId='+this.data.Client_id;
   }
  
  
   window.open(url, "_blank");
    
  }

  generateInvoice(invoice: any, type: string) {
    let url ='' 
    if(type=='pdf'){
     
     url = this.reporterURL+type+'/MonederoXiga.aspx?rptId=data&DataServer=NexusFEMonedero&langId=2&rptName=rpt_invoiceSingleV3&invoiceId='+invoice.reference;
    }else{
      

     url = this.reporterURL+'pdf/MonederoXiga.aspx?rptId=xml&invoiceId='+invoice.reference;
    }
   
    window.open(url, "_blank");
  }

  getFile(data:any){
   
  }
}
